import { targetingTypes } from '../../../LineItemDv360Create/fields'
import {
  CATEGORIES,
  EXCLUDED_CATEGORIES,
  KEYWORD_EXCLUSION_LISTS,
  KEYWORDS_TABLE,
  TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS,
  YES_USING_PRE_SAVED_KEYWORD_EXCLUSION_LISTS
} from '../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'
import { OPTION_YES } from '../../../../../../constants/forms'

export const getInitialValues = (targeting, attachedNegativeKeywordsLists) => {
  const formattedAttachedNegativeKeywordsLists = attachedNegativeKeywordsLists.map(item => ({
    ...item,
    value: item.id,
    label: item.name
  }))

  const categoriesOptions = targeting.filter(
    option => option.type === targetingTypes.TARGETING_TYPE_CATEGORY && !option.negative
  )
  const excludedCategoriesOptions = targeting.filter(
    option => option.type === targetingTypes.TARGETING_TYPE_CATEGORY && option.negative
  )
  const formattedCategoriesOptions = categoriesOptions.map(item => ({
    value: item.targeting_option_id,
    label: item.display_name
  }))
  const formattedExcludedCategoriesOptions = excludedCategoriesOptions.map(item => ({
    value: item.targeting_option_id,
    label: item.display_name
  }))

  const keywordsData = targeting.reduce(
    (acc, option) => {
      if (option.type === targetingTypes.TARGETING_TYPE_KEYWORD) {
        option.negative ? acc.excluded.push(option.keyword) : acc.included.push(option.keyword)
      }
      return acc
    },
    { included: [], excluded: [] }
  )

  const maxLength = Math.max(keywordsData.included.length, keywordsData.excluded.length)
  const keywordsTable = Array.from(
    {
      length:
        maxLength >= 10
          ? maxLength
          : // if maxLength is less than 10, fill the array with 10 elements
            10
    },
    (_, index) => {
      return [{ value: keywordsData.included[index] }, { value: keywordsData.excluded[index] }]
    }
  )

  return {
    [TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS]:
      keywordsData.included.length || keywordsData.excluded.length
        ? OPTION_YES
        : YES_USING_PRE_SAVED_KEYWORD_EXCLUSION_LISTS,
    [KEYWORD_EXCLUSION_LISTS]: formattedAttachedNegativeKeywordsLists,
    [CATEGORIES]: formattedCategoriesOptions,
    [EXCLUDED_CATEGORIES]: formattedExcludedCategoriesOptions,
    [KEYWORDS_TABLE]: keywordsTable
  }
}
